import React, { useRef } from 'react';
import DialogShell from './dialog-shell';
import { TWButton } from '../../../../components/ui';
import { formatCurrency } from '../../../../utils/baseUtils';

const Line = ({ title, value, hint }) => (
  <div className="rounded-md border border-slate-100 bg-slate-50/80 px-4 py-3 dark:border-slate-700 dark:bg-slate-900/40">
    <div className="flex items-center justify-between gap-3">
      <p className="text-sm font-bold text-slate-900 dark:text-slate-100">
        {title}
      </p>
      <p className="tabular-nums text-sm font-bold text-slate-900 dark:text-slate-100">
        {value}
      </p>
    </div>
    {hint ? (
      <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{hint}</p>
    ) : null}
  </div>
);

const TaxFeesDialog = ({ open, onClose, orderDetail }) => {
  const cancelRef = useRef(null);
  if (!orderDetail?.store) return null;

  return (
    <DialogShell
      open={open}
      onClose={onClose}
      maxWidth="sm:max-w-lg"
      initialFocus={cancelRef}
    >
      <div className="px-6 pb-2 pt-6">
        <h2 className="text-lg font-bold text-slate-900 dark:text-slate-100">
          Sales Tax & Fees
        </h2>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Detailed breakdown of taxes and surcharges added to this order.
        </p>
      </div>

      <div className="space-y-3 px-6 py-4">
        <Line
          title={`Sales Tax${
            orderDetail.store.tax ? ` (${orderDetail.store.tax}%)` : ''
          }`}
          value={formatCurrency(orderDetail.tax)}
          hint="Sales tax is added to your order as required by local regulations."
        />
        {orderDetail.crvtax !== 0 && (
          <Line
            title="CRV Tax"
            value={formatCurrency(orderDetail.crvtax)}
            hint="The CRV fee, included in the price of beverages in California."
          />
        )}
        {orderDetail.fee !== 0 && (
          <Line
            title="Platform Fee"
            value={formatCurrency(orderDetail.fee)}
            hint="Retained by Thisway to cover the costs of developing, maintaining, and operating the kiosk ordering platform. This fee is not a tip or service charge and collected by Thisway, not restaurant."
          />
        )}
      </div>

      <div className="flex justify-end gap-3 border-t border-slate-100 bg-slate-50 px-6 py-4 dark:border-slate-700 dark:bg-slate-900/40">
        <TWButton ref={cancelRef} label="Got it" onClick={onClose} />
      </div>
    </DialogShell>
  );
};

export default TaxFeesDialog;
